import React from "react";
import { JHALA_GLOBAL_CSS, TopStrip, Header, Footer, Reveal, TagChip } from "components/jhala/Layout.js";

export default function PrivacyPolicyPage() {
  return (
    <div style={{ fontFamily: "'Inter', sans-serif", background: "#F6F4EE", color: "#0A0F1E" }}>
      <style>{JHALA_GLOBAL_CSS}</style>
      <TopStrip />
      <Header />

      <section style={{ background: "#0A0F1E", color: "#F6F4EE", padding: "56px 24px 48px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <Reveal>
            <TagChip>$ jhalatech --legal privacy</TagChip>
            <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "clamp(26px, 3.6vw, 38px)", lineHeight: 1.15, margin: "16px 0 0" }}>
              Privacy Policy
            </h1>
          </Reveal>
        </div>
      </section>

      <section style={{ padding: "60px 24px 90px", background: "#F6F4EE" }}>
        <div style={{ maxWidth: 800, margin: "0 auto", background: "#FFFFFF", border: "1px solid #DCD8CC", borderRadius: 8, padding: "40px 36px" }}>
          <Reveal>
            <div className="legal-content">
              <p>Effective Date: July 01, 2025</p>

              <h2>1. Purpose & Commitment</h2>
              <p>At JhalaTech, we are committed to protecting the privacy and personal information of all individuals we interact with – including our employees, trainees, clients, customers, business partners, merchants, and job applicants. This Privacy Policy outlines how we manage, store, and process personal data with utmost transparency, responsibility, and compliance with applicable laws.</p>
              <p>Any unauthorized or unethical use of personal data is strictly prohibited and subject to legal action.</p>

              <h2>2. What "Processing" Means</h2>
              <p>The term "processing" refers to any operation performed on personal data including: collecting, recording, storing, using, analyzing, combining, disclosing, transferring, or deleting it.</p>
              <ul>
                <li>Basic identifiers: full name, email address, phone number, address</li>
                <li>Account credentials: usernames, encrypted passwords</li>
                <li>Demographic data: age, gender, race (where applicable)</li>
                <li>Employment details: job history, education, certifications, salary (for recruitment purposes)</li>
                <li>Health or biometric information (only if voluntarily submitted)</li>
                <li>Device and usage information (via cookies and analytics)</li>
              </ul>
              <p>Your personal data is treated as confidential and is considered a valuable asset to our company.</p>

              <h2>3. Data Storage & Security</h2>
              <p>Your personal data is securely stored in our application databases on servers with restricted external access. Sensitive data (such as passwords) is encrypted using industry-standard encryption techniques.</p>
              <p>When accessing third-party platforms like Shopify or BigCommerce, we use temporary OAuth2 tokens to ensure secure authentication.</p>
              <p>We retain personal data for a period of <strong>3 years</strong> after the termination of our services or as required by applicable law.</p>

              <h2>4. Data Sharing</h2>
              <p>We do not sell or share your personal data with third parties for marketing purposes. However, we may share limited data with trusted partners or service providers strictly to fulfill business functions, such as:</p>
              <ul>
                <li>Payment processing</li>
                <li>Hosting services</li>
                <li>Analytics platforms (e.g., Google Analytics)</li>
                <li>Legal or compliance purposes</li>
              </ul>

              <h2>5. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access the personal data we hold about you</li>
                <li>Request correction, update, or deletion of your data</li>
                <li>Object to or restrict processing under certain circumstances</li>
                <li>Lodge a complaint with a data protection authority</li>
              </ul>
              <p>To exercise these rights, please contact us using the details provided at the end of this policy.</p>

              <h2>6. Data Transfers</h2>
              <p>Your personal data may be transferred and stored outside your country of residence, including in countries such as <strong>Canada</strong> and the <strong>United States</strong> where data protection laws may differ. By using our services, you agree to such transfers.</p>

              <h2>7. Changes to This Policy</h2>
              <p>We may update this Privacy Policy from time to time to reflect changes in our practices or for legal reasons. When we do, we will update the "Effective Date" at the top of this page.</p>

              <h2>8. Contact Us</h2>
              <p>If you have any questions about this Privacy Policy, or if you would like to make a request regarding your personal data, you can contact us at:</p>
              <p>
                📧 Email: contact@jhalatech.com<br />
                🏢 Address: [Your Company Address]<br />
                📞 Phone: +91-XXXXXXXXXX
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
}
